<template>
  <UserLayout>
    <SessionJoinModal
      :isSessionJoinModalOpen="isSessionJoinModalOpen"
      :session_thumbnail_url="
        baseUrlSrc(session.details && session.details.thumbnail_url)
      "
      :sessionTitle="session && session.details && session.details.title"
      :sessionDate="
        handleMonthDateTime(
          sessionJoinData.batch && sessionJoinData.batch.start_date
        )
      "
      :sessionTime="
        handleHour12(
          sessionJoinData.batch && sessionJoinData.batch.start_date
        ) +
        ' - ' +
        handleHour12(sessionJoinData.batch && sessionJoinData.batch.end_date)
      "
      :sessionCost="
        sessionJoinData && sessionJoinData.batch && sessionJoinData.batch.cost
      "
      :wallet_balance="wallet_balance"
      :handleJoinClick="handleJoinClick"
      :handleAddMoney="handleButtonClick"
    />
    <div class="" id="overview">
      <!-- top heading bar starts here -->
        <div class="flex items-center justify-between scrolltoview-nav"
          v-if="USERROUTES.includes($route.name)"
        >
        <scrollactive
          active-class="scroll-active"
          :offset="125"
          class="hidden lg:py-0 lg:flex lg:space-x-8"
          aria-label="Global"
        >
          <a
            href="#overview"
            data-section-selector="#overview"
            class="scrollactive-item text-gray-dark whitespace-nowrap px-0 font-normal text-sm"
          >
            Overview
          </a>

          <a
            href="#about-the-trainer"
            data-section-selector="#about-the-trainer"
            class="scrollactive-item text-gray-dark whitespace-nowrap px-0 font-normal text-sm"
          >
            About The Trainer
          </a>

          <a
            href="#reviews"
            data-section-selector="#reviews"
            class="scrollactive-item text-gray-dark whitespace-nowrap px-0 font-normal text-sm"
          >
            Reviews
          </a>
        </scrollactive>

        <div class="flex items-center space-x-2">
          <!-- <button
                  type="button"
                  class="ring-1 ring-gray-300 px-2 py-1 text-gray-darkest rounded-sm focus:outline-none"
                  @click="sessionCourseFavouriteHandler"
                >
                  Heart icon
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-6 w-6"
                    :class="{
                      'text-red-500': heartFill === true,
                    }"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </button>
                <button
                  type="button"
                  class="ring-1 ring-gray-300 px-2 py-1 w-8 text-gray-light focus:outline-none rounded-sm"
                >
                  <span>
                    {{ favouriteCount }}
                  </span>
                </button> -->
            <button
              type="button"
              class="ring-1 ring-gray-300 p-1 text-gray-light rounded-md focus:bg-green-light focus:text-white focus:outline-none"
              title="Share link"
              @click.prevent="handleShareButton"
            >
              
              <!-- Share icon -->
              <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6"
              viewBox="0 0 33 31"
            >
              <g id="noun_Share_4241699" transform="translate(-0.542 -1.899)">
                <g id="Layer_10" data-name="Layer 10">
                  <path
                    id="Path_2127"
                    data-name="Path 2127"
                    d="M27.9,2.682a.881.881,0,0,0-.51-.276c-.013,0-.023-.007-.036-.007s-.024.007-.037.007a.677.677,0,0,0-.7.69v3.91c-2.219-.142-6.786.172-8.77,4.682C15.108,17.9,18.912,24.1,19.075,24.36a.7.7,0,0,0,.591.328.687.687,0,0,0,.144-.015.7.7,0,0,0,.546-.582c.812-5.616,3.957-8.089,6.262-9.161V20.1a.7.7,0,0,0,1.154.527L37.607,12.1a.7.7,0,0,0,0-1.056Zm.109,15.89v-4.68a.7.7,0,0,0-.93-.658,12.008,12.008,0,0,0-7.691,8.615c-.876-2.142-1.891-5.921-.268-9.6,1.434-3.259,4.494-3.883,6.624-3.883.331,0,.635.016.912.038v.737a.7.7,0,0,0,1.395,0V4.655l8.03,6.923Z"
                    transform="translate(-4.806)"
                    stroke="#222"
                    stroke-width="1"
                  />
                  <path
                    id="Path_2128"
                    data-name="Path 2128"
                    d="M30.256,19.866a.7.7,0,0,0-.7.694v5.931a4.7,4.7,0,0,1-4.7,4.685H7.138a4.7,4.7,0,0,1-4.7-4.685V9.019a4.7,4.7,0,0,1,4.7-4.685h7.89a.694.694,0,1,0,0-1.389H7.138a6.092,6.092,0,0,0-6.1,6.074V26.491a6.092,6.092,0,0,0,6.1,6.074H24.857a6.092,6.092,0,0,0,6.1-6.074V20.56a.7.7,0,0,0-.7-.694Z"
                    transform="translate(0 -0.165)"
                    stroke="#222"
                    stroke-width="1"
                  />
                </g>
              </g>
            </svg>
            </button>
        </div>
      </div>
      <!-- top heading bar ends here -->
      <div class="breadcrumb text-sm font-normal text-blue-600 pt-8 pb-1 mt-4">
        {{ session && session.details && session.details.category_name }}
      </div>
      <section class="grid grid-cols-12">
        <div class="md:col-span-8 col-span-12 xl:mr-20 md:mr-10 mr-0">
          <section>
            <div class="space-y-4">
              <h6
                class="text-xl2 leading-normal mt-0 pb-1 text-black font-semibold capitalize"
              >
                {{ session && session.details && session.details.title }}
              </h6>
              <div class="flex items-center space-x-2 pb-4 gap-1">
                <Avatar
                  :classStr="'h-8 w-8'"
                  :src="
                    baseUrlSrc(
                      trainer &&
                        trainer.details &&
                        trainer.details.thumbnail_url
                    )
                  "
                />
                <p class="capitalize text-sm font-bold text-black">
                  {{ trainer && trainer.details && trainer.details.name }}
                </p>
                <div class="flex items-center">
                  <Rating :data="trainer && trainer.average_rating" />
                </div>
              </div>
              <SessionDetailsComponents
                v-if="session && session.details"
                :details="session && session.details"
                :supportingImages="userSessionDetail.supporting_images"
                :total_student="session && session.total_student"
                :zoom_meeting="batches && batches.zoom_meeting"
                v-on:give-review="handleSessionFeedbackModal"
              />
            </div>
          </section>
          <hr class="text-gray-400 w-full" />
          <!-- About this class -->
          <section id="description">
            <div class="py-4">
              <h6
                class="text-xl leading-normal mt-0 mb-4 text-gray-dark font-semibold"
              >
                About this class
              </h6>
              <p class="text-gray-dark text-xs">
                {{
                  isSessionDetailsDesc
                    ? session && session.details && session.details.description
                    : handleStr(
                        session &&
                          session.details &&
                          session.details.description,
                        TWOHUNDRED
                      )
                }}
              </p>
              <button
                type="button"
                class="h-8 text-sm text-green-light transition-colors duration-150 rounded-lg cursor-pointer focus:outline-none mt-4"
                @click.prevent="isSessionDetailsDesc = !isSessionDetailsDesc"
                v-if="
                  session &&
                  session.details &&
                  session.details.description &&
                  session.details.description.length > TWOHUNDRED
                "
              >
                Show {{ isSessionDetailsDesc ? "less" : "more" }}
              </button>
            </div>
          </section>
          <hr class="text-gray-400 w-full" />
          <!-- Meet your trainer -->
          <section class="mt-4" id="about-the-trainer">
            <div class="py-4">
              <h6
                class="text-xl leading-normal mt-0 mb-4 text-gray-dark font-semibold"
              >
                About the trainer
              </h6>

              <div class="relative flex mb-4 space-x-3">
                <Avatar
                  :classStr="'h-12 w-12'"
                  :src="
                    baseUrlSrc(
                      trainer &&
                        trainer.details &&
                        trainer.details.thumbnail_url
                    )
                  "
                />
                <div>
                  <router-link
                    class="text-md text-gray-dark font-semibold capitalize hover:underline"
                    :to="{
                      name: 'UserTrainerAbout',
                      params: {
                        trainer_id:
                          trainer && trainer.details && trainer.details.id,
                      },
                    }"
                    v-if="trainer && trainer.details && trainer.details.id"
                  >
                    {{ trainer && trainer.details && trainer.details.name }}
                  </router-link>
                  <p class="text-sm text-gray-light">
                    {{
                      (trainer &&
                        trainer.details &&
                        trainer.details.category_name) ||
                      "-"
                    }}
                  </p>
                </div>
              </div>
              <p class="text-gray-dark text-base leading-7">
                {{
                  isTrainerDetailsDesc
                    ? trainer && trainer.details && trainer.details.description
                    : handleStr(
                        trainer &&
                          trainer.details &&
                          trainer.details.description,
                        TWOHUNDRED
                      )
                }}
              </p>
              <button
                type="button"
                class="h-8 text-sm text-green-light transition-colors duration-150 rounded-lg cursor-pointer focus:outline-none mt-4"
                @click.prevent="isTrainerDetailsDesc = !isTrainerDetailsDesc"
                v-if="
                  trainer &&
                  trainer.details &&
                  trainer.details.description &&
                  trainer.details.description.length > TWOHUNDRED
                "
              >
                Show {{ isTrainerDetailsDesc ? "less" : "more" }}
              </button>
            </div>
          </section>

          <!-- Session feedback -->
          <section class="space-y-4 py-4 w-full" id="reviews">
            <div class="flex items-center space-x-4 flex-row">
              <h6
                class="text-base font-light leading-normal mt-0 text-gray-dark"
              >
                Class Ratings
              </h6>
              <p class="capitalize text-sm font-semibold">
                {{ sessionRatingsData && sessionRatingsData.total > 1 ? `${sessionRatingsData.total || 0} Reviews` : `${sessionRatingsData.total || 0} Review` }} 
              </p>
              <!--
              <div class="flex items-center">
                <Rating
                  :data="userReviewRating && userReviewRating.avg_rating"
                />
                <span class="text-yellow-medium px-2">
                  {{
                    intToFloat(userReviewRating && userReviewRating.avg_rating)
                  }}
                </span>
              </div>
              -->
            </div>

            <div
              class="flex items-center justify-between ring-1 ring-gray-300 p-2 rounded-lg"
              v-if="
                userReviewRating &&
                !userReviewRating.is_added &&
                getToken() &&
                session &&
                session.details &&
                session.details.status == STATUS_COMPLETED
              "
            >
              <p class="text-sm text-gray">
                Share your feedback about the Class with everyone
              </p>
              <button
                type="button"
                class="h-8 px-4 m-2 text-sm text-white transition-colors duration-150 bg-green-light rounded-md focus:shadow-outline hover:bg-green-light hover:text-white"
                @click.prevent="handleSessionFeedbackModal"
              >
                Give Review
              </button>
            </div>
            <!--
            <div
              class="flex md:space-x-4 pt-2"
              v-if="
                userReviewRating &&
                userReviewRating.most_liked &&
                userReviewRating.most_liked.length
              "
            >
              <div class="md:w-1/2 rounded-md py-6 h-full px-8 bg-f5f6ed">
                <h6 class="text-md text-gray-dark font-semibold mb-4">
                  Most Liked
                </h6>
                <ul class="space-y-4">
                  <li
                    v-for="(d, i) in userReviewRating.most_liked.slice(0, 4)"
                    :key="i"
                  >
                    <div
                      class="flex items-center space-x-2 bg-white text-sm rounded-md p-1 px-2"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-5 w-5 text-green-light"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z"
                          clip-rule="evenodd"
                        />
                      </svg>
                      <span class="font-bold">{{ d.count }}</span>
                      <p class="px-4 capitalize font-normal text-gray-dark">
                        {{ d.value }}
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="bg-f5f7ed md:w-1/2 md:mt-0 mt-4 mt-4 h-full rounded-md px-8 py-6">
                <h6 class="text-md text-gray-dark font-semibold mb-4">
                  Expectations Met?
                </h6>
                <ul
                  class="space-y-4"
                  v-if="
                    userReviewRating &&
                    userReviewRating.expectations_met &&
                    userReviewRating.expectations_met.length
                  "
                >
                  <li
                    v-for="(d, i) in userReviewRating.expectations_met"
                    :key="i"
                  >
                    <div
                      class="flex items-center justify-between text-sm space-x-2"
                    >
                      <label for="file " class="w-20">
                        {{ d.expectation }}
                      </label>
                      <progress
                        id="file"
                        class="bg-white"
                        :value="d.percentage"
                        max="100"
                      >
                        {{ d.percentage }}%
                      </progress>
                      <span class="text-sm">{{ d.percentage }}%</span>
                    </div>
                  </li>
                  <li>
                    <div
                      class="flex items-center justify-between text-sm space-x-2"
                    >
                      <label for="file " class="w-20">Somewhat </label>
                      <progress id="file" class="bg-white" value="0" max="100">
                        0%
                      </progress>
                      <span class="text-sm px-2">0%</span>
                    </div>
                  </li>
                  <li>
                    <div
                      class="flex items-center justify-between text-sm space-x-2"
                    >
                      <label for="file " class="w-20">Exceeded </label>
                      <progress id="file" class="bg-white" value="0" max="100">
                        0%
                      </progress>
                      <span class="text-sm px-2">0%</span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            <div class="flex sm:items-center mt-8 flex-col sm:flex-row">
              <label
                class="text-gray-dark text-sm cursor-pointer"
                :class="orderBy == 'highest_rated' ? 'font-semibold' : ''"
                @click="handleOrderBy"
              >
                <span> Highest Rated <span class="px-1">&bull;</span></span>
                <input
                  type="checkbox"
                  value="highest_rated"
                  class="invisible"
                />
              </label>
              <label
                class="text-gray-dark text-sm cursor-pointer font-medium"
                :class="orderBy == 'lowest_rated' ? 'font-semibold' : ''"
                @click="handleOrderBy"
              >
                <span> Lowest Rated <span class="px-1">&bull;</span></span>
                <input type="checkbox" value="lowest_rated" class="invisible" />
              </label>
              <label
                class="text-gray-dark text-sm cursor-pointer font-medium"
                :class="orderBy == 'most_recent' ? 'font-semibold' : ''"
                @click="handleOrderBy"
              >
                <span> Most Recent</span>
                <input type="checkbox" value="most_recent" class="invisible" />
              </label>
            </div>
            <SessionReviewList
              :data="userReviewRating && userReviewRating.rating_data"
              :ratingLikeId="
                userReviewRating && userReviewRating.rating_like_id
              "
              v-on:del-rating="handleRatingDel"
              v-on:edit-rating="handleRatingEdit"
            />
            -->
            <SessionRatingsList
              :ratingData="sessionRatingsData.data"
              :nextPage="sessionRatingsData.next_page_url"
              :handleReadMore="getUserReviewsHandler"
              :sessionId="session && session.details && session.details.id"
            />
            <SessionFeedbackModal
              :isSessionFeedbackModal="isSessionFeedbackModal"
              v-on:is-modal-open="handleSessionFeedbackModal"
              :ratingEditObj="ratingEditObj"
            />
          </section>
        </div>

        <div class="md:col-span-4 col-span-12">
          <section style="display: unset">
            <div
              class="sticky w-full right-0"
              style="top: 60px"
            >
              <div
                class="p-4 rounded-lg shadow-lg bg-gray-lightest overflow-y-auto booking-modal"
                v-if="step === 1"
              >
                <transition name="fade" mode="out-in">
                  <section v-if="!isBookSession">
                    <div class="flex flex-col">
                      <h5 class="font-bold leading-7 text-xl mb-6 capitalize">
                        {{
                          session && session.details && session.details.title
                        }}
                      </h5>
                      <p
                        class="font-semibold text-currency"
                        v-if="
                          session &&
                          session.details &&
                          session.details.cost !== 0
                        "
                      >
                        ${{
                          session && session.details && session.details.cost
                        }}
                      </p>
                      <p class="font-semibold text-lg" v-else>Free Class</p>
                    </div>

                    <div key="off">
                      <!-- Booked session -->
                      <div
                        v-if="
                          batches &&
                          batches.joined &&
                          batches.joined.data &&
                          batches.joined.data.length
                        "
                      >
                        <p
                          class="text-black uppercase text-xs mb-4 mt-6 font-semibold"
                        >
                          Booked Class
                        </p>
                        <SessionBatchesJoined
                          v-if="session && Object.keys(session).length"
                          v-on:batch-id="handleBatchesJoinedModal"
                          :data="
                            batches && batches.joined && batches.joined.data
                          "
                          :sessionDetail="session"
                        />
                      </div>

                      <!-- Upcoming sessions -->
                      <div>
                        <p class="text-gray-900 uppercase text-xs mt-6 mb-5">
                          Upcoming Classes
                        </p>
                        <SessionBatchesAvailable
                          v-on:batch-id="handleBookSession"
                          :data="
                            batches &&
                            batches.available &&
                            batches.available.data
                          "
                        />
                      </div>

                      <!-- show more -->
                      <div
                        v-if="
                          batches &&
                          batches.available &&
                          batches.available.next_page_url
                        "
                        class="hidden md:inline"
                      >
                        <button
                          class="h-8 text-sm text-green-light transition-colors duration-150 rounded-lg focus:outline-none"
                          @click="
                            handleShowMoreAvail(batches.available.next_page_url)
                          "
                        >
                          Show more
                        </button>
                      </div>

                      <!-- Show less -->
                      <div
                        v-if="
                          batches &&
                          batches.available &&
                          !batches.available.next_page_url &&
                          batches.available.total > 3
                        "
                        class="hidden md:inline"
                      >
                        <button
                          class="h-8 text-sm text-green-light transition-colors duration-150 rounded-lg focus:outline-none"
                          @click="
                            handleShowLessAvail(
                              batches.available.first_page_url
                            )
                          "
                        >
                          Show less
                        </button>
                      </div>
                    </div>
                  </section>

                  <!-- <transition
                    name="fade"
                    mode="out-in"
                    :duration="{enter: 1000}"
                    v-else-if="getUser().wallet_balance > session.details.cost"
                  >
                    <section>
                      <section>
                        <div
                          class="flex flex-col justify-center items-center mt-8"
                        >
                          <p class="font-normal text-xl leading-7 pb-5">
                            Total Balance
                          </p>
                          <p class="text-4xl font-semibold pb-8">$0</p>
                          <img
                            :src="require(`@/assets/img/GroupWallet.png`)"
                            alt="Wallet"
                          />
                          <div
                            class="pt-8 flex flex-col text-2xl font-semibold w-full items-center pb-3"
                          >
                            <p class="text-green-light">Top-up your Wallet</p>
                            <p>using GrooveSell</p>
                          </div>
                          <div
                            class="flex items-center text-xs font-normal text-gray-800"
                          >
                            Securely add funds to your wallet using GrooveSell
                          </div>
                          <button
                            class="w-full text-white bg-green-light font-semibold text-base leading-6 py-3 mt-20 rounded-lg mb-8 focus:outline-none"
                            @click="openPaymentModal = true"
                          >
                            + Add Money
                          </button>
                        </div>
                      </section>
                    </section>
                  </transition> -->
                  <section v-else>
                    <div class="flex flex-col">
                      <h5 class="font-bold leading-7 text-xl mb-6 capitalize">
                        {{
                          session && session.details && session.details.title
                        }}
                      </h5>
                      <p class="font-semibold text-currency">
                        ${{
                          session && session.details && session.details.cost
                        }}
                      </p>
                    </div>
                    <div key="on" class="pt-11">
                      <button
                        type="button"
                        class="w-full h-12 px-3 text-white transition-colors duration-150 bg-gray-trainer rounded-md focus:shadow-outline hover:bg-gray-300 text-sm mb-6"
                      >
                        <div class="flex items-center justify-between">
                          <label class="text-gray-700 flex items-center">
                            <input
                              type="checkbox"
                              value=""
                              v-model="interactTrainer"
                              class="h-5 w-5 rounded"
                            />
                            <span
                              class="ml-4 text-gray-dark text-xs font-normal"
                            >
                              Want to interact with trainer?
                            </span>
                          </label>

                          <span class="text-gray-dark font-semibold text-base">
                            + $2.00
                          </span>
                        </div>
                      </button>
                      <p class="text-gray-darker text-xs pb-10">
                        {{
                          session &&
                          session.details &&
                          session.details.description
                        }}
                      </p>
                      <div class="flex flex-col pb-4">
                        <p class="font-semibold text-base leading-6">
                          {{ dateFormat(session.details.start_date) }}
                        </p>
                        <p
                          class="font-normal text-xs leading-4 text-gray-light"
                        >
                          {{ handleHour12(session.details.start_date) }} -
                          {{ handleHour12(session.details.end_date) }}
                        </p>
                      </div>
                      <button
                        type="button"
                        class="w-full py-3 px-6 text-white duration-100 bg-green-light rounded-md focus:outline-none hover:bg-green-light text-sm"
                        @click.prevent="handleJoinClick"
                      >
                        Join Now -- ${{
                          (session && session.details && session.details.cost) +
                          (interactTrainer ? 2 : 0)
                        }}
                      </button>
                      <div class="flex items-center justify-between pt-4">
                        <p class="text-gray-darker text-xs">
                          You have ${{ wallet_balance }} left in your wallet
                        </p>
                        <button
                          type="button"
                          class="font-semibold text-gray-dark text-md"
                          @click.prevent="handleButtonClick"
                        >
                          + Add Money
                        </button>
                      </div>
                    </div>
                  </section>
                </transition>
              </div>
              <section v-else-if="step === 2">
                <div
                  class="px-8 pb-8 rounded-lg shadow-lg bg-gray-lightest ring-1 ring-gray-300 overflow-y-auto"
                >
                  <div class="flex justify-center items-center pt-16 pb-8">
                    <svg
                      width="80"
                      height="80"
                      viewBox="0 0 80 80"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_1037_6057)">
                        <path
                          d="M36.6657 76.6145C16.4497 76.6145 0 60.1655 0 39.9494C0 19.7334 16.4497 3.28369 36.6657 3.28369C43.6955 3.28369 50.5349 5.2868 56.4448 9.08002C57.605 9.82707 57.945 11.3736 57.1979 12.5369C56.4484 13.7002 54.9049 14.0365 53.7416 13.2901C48.6417 10.0132 42.7355 8.28354 36.6657 8.28354C19.2059 8.28354 4.99984 22.4896 4.99984 39.9494C4.99984 57.4086 19.2059 71.6147 36.6657 71.6147C54.1249 71.6147 68.331 57.4086 68.331 39.9494C68.331 38.9058 68.281 37.8725 68.1845 36.8563C68.0515 35.4793 69.0579 34.2593 70.4312 34.1262C71.8111 33.9993 73.0275 34.9996 73.1612 36.3729C73.2741 37.5496 73.3308 38.7428 73.3308 39.9494C73.3308 60.1655 56.8818 76.6145 36.6657 76.6145Z"
                          fill="#8DC73F"
                        />
                        <path
                          d="M40.8322 48.2823C40.1926 48.2823 39.5524 48.0388 39.0659 47.5493L24.0664 32.5497C23.0899 31.5726 23.0899 29.9894 24.0664 29.0129C25.0429 28.0363 26.6261 28.0363 27.6027 29.0129L40.8359 42.2461L75.731 7.35032C76.7082 6.37379 78.2914 6.37379 79.2679 7.35032C80.2444 8.32685 80.2444 9.91005 79.2679 10.8866L42.6022 47.5523C42.1121 48.0388 41.4725 48.2823 40.8322 48.2823Z"
                          fill="#8DC73F"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1037_6057">
                          <rect width="80" height="80" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <p
                    class="flex justify-center items-center font-semibold text-base"
                  >
                    Congratulations! Session Booked!
                  </p>
                  <div class="flex justify-center items-center pt-6 pb-10">
                    <svg
                      width="48"
                      height="48"
                      viewBox="0 0 48 48"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M44 4.8H40V3.2C40 2.35131 39.6629 1.53737 39.0627 0.937258C38.4626 0.337142 37.6487 0 36.8 0C35.9513 0 35.1374 0.337142 34.5373 0.937258C33.9371 1.53737 33.6 2.35131 33.6 3.2V4.8H27.2V3.2C27.2 2.35131 26.8629 1.53737 26.2627 0.937258C25.6626 0.337142 24.8487 0 24 0C23.1513 0 22.3374 0.337142 21.7373 0.937258C21.1371 1.53737 20.8 2.35131 20.8 3.2V4.8H14.4V3.2C14.4 2.35131 14.0629 1.53737 13.4627 0.937258C12.8626 0.337142 12.0487 0 11.2 0C10.3513 0 9.53737 0.337142 8.93726 0.937258C8.33714 1.53737 8 2.35131 8 3.2V4.8H4C2.93913 4.8 1.92172 5.22143 1.17157 5.97157C0.421427 6.72172 0 7.73913 0 8.8V40.8C0 41.8609 0.421427 42.8783 1.17157 43.6284C1.92172 44.3786 2.93913 44.8 4 44.8H26.4C26.6122 44.8 26.8157 44.7157 26.9657 44.5657C27.1157 44.4156 27.2 44.2122 27.2 44C27.2 43.7878 27.1157 43.5843 26.9657 43.4343C26.8157 43.2843 26.6122 43.2 26.4 43.2H4C3.36406 43.1981 2.75472 42.9446 2.30504 42.4949C1.85537 42.0453 1.6019 41.4359 1.6 40.8V16H46.4V29.6C46.4 29.8122 46.4843 30.0156 46.6343 30.1657C46.7843 30.3157 46.9878 30.4 47.2 30.4C47.4122 30.4 47.6157 30.3157 47.7657 30.1657C47.9157 30.0156 48 29.8122 48 29.6V8.8C48 7.73913 47.5786 6.72172 46.8284 5.97157C46.0783 5.22143 45.0609 4.8 44 4.8ZM35.2 3.2C35.2 2.77565 35.3686 2.36869 35.6686 2.06863C35.9687 1.76857 36.3756 1.6 36.8 1.6C37.2243 1.6 37.6313 1.76857 37.9314 2.06863C38.2314 2.36869 38.4 2.77565 38.4 3.2V8C38.4 8.42435 38.2314 8.83131 37.9314 9.13137C37.6313 9.43143 37.2243 9.6 36.8 9.6C36.3756 9.6 35.9687 9.43143 35.6686 9.13137C35.3686 8.83131 35.2 8.42435 35.2 8V3.2ZM22.4 3.2C22.4 2.77565 22.5686 2.36869 22.8686 2.06863C23.1687 1.76857 23.5757 1.6 24 1.6C24.4243 1.6 24.8313 1.76857 25.1314 2.06863C25.4314 2.36869 25.6 2.77565 25.6 3.2V8C25.6 8.42435 25.4314 8.83131 25.1314 9.13137C24.8313 9.43143 24.4243 9.6 24 9.6C23.5757 9.6 23.1687 9.43143 22.8686 9.13137C22.5686 8.83131 22.4 8.42435 22.4 8V3.2ZM9.6 3.2C9.6 2.77565 9.76857 2.36869 10.0686 2.06863C10.3687 1.76857 10.7757 1.6 11.2 1.6C11.6243 1.6 12.0313 1.76857 12.3314 2.06863C12.6314 2.36869 12.8 2.77565 12.8 3.2V8C12.8 8.42435 12.6314 8.83131 12.3314 9.13137C12.0313 9.43143 11.6243 9.6 11.2 9.6C10.7757 9.6 10.3687 9.43143 10.0686 9.13137C9.76857 8.83131 9.6 8.42435 9.6 8V3.2ZM46.4 14.4H1.6V8.8C1.6019 8.16406 1.85537 7.55472 2.30504 7.10504C2.75472 6.65536 3.36406 6.4019 4 6.4H8V8C8 8.84869 8.33714 9.66262 8.93726 10.2627C9.53737 10.8629 10.3513 11.2 11.2 11.2C12.0487 11.2 12.8626 10.8629 13.4627 10.2627C14.0629 9.66262 14.4 8.84869 14.4 8V6.4H20.8V8C20.8 8.84869 21.1371 9.66262 21.7373 10.2627C22.3374 10.8629 23.1513 11.2 24 11.2C24.8487 11.2 25.6626 10.8629 26.2627 10.2627C26.8629 9.66262 27.2 8.84869 27.2 8V6.4H33.6V8C33.6 8.84869 33.9371 9.66262 34.5373 10.2627C35.1374 10.8629 35.9513 11.2 36.8 11.2C37.6487 11.2 38.4626 10.8629 39.0627 10.2627C39.6629 9.66262 40 8.84869 40 8V6.4H44C44.6359 6.4019 45.2453 6.65536 45.695 7.10504C46.1446 7.55472 46.3981 8.16406 46.4 8.8V14.4Z"
                        fill="#130F26"
                      />
                      <path
                        d="M37.6002 27.2C35.5433 27.2 33.5325 27.8099 31.8223 28.9527C30.112 30.0954 28.779 31.7197 27.9919 33.62C27.2047 35.5204 26.9987 37.6115 27.4 39.6289C27.8013 41.6463 28.7918 43.4994 30.2463 44.9539C31.7008 46.4083 33.5539 47.3988 35.5713 47.8001C37.5887 48.2014 39.6798 47.9954 41.5801 47.2083C43.4805 46.4211 45.1047 45.0882 46.2475 43.3779C47.3902 41.6676 48.0002 39.6569 48.0002 37.5999C47.997 34.8427 46.9003 32.1992 44.9506 30.2495C43.0009 28.2999 40.3575 27.2031 37.6002 27.2ZM37.6002 46.3999C35.8597 46.3999 34.1583 45.8838 32.7112 44.9169C31.264 43.9499 30.1361 42.5756 29.4701 40.9676C28.804 39.3596 28.6297 37.5902 28.9693 35.8832C29.3088 34.1761 30.147 32.6081 31.3777 31.3774C32.6084 30.1467 34.1764 29.3086 35.8834 28.969C37.5904 28.6295 39.3598 28.8038 40.9678 29.4698C42.5758 30.1359 43.9502 31.2638 44.9171 32.7109C45.8841 34.1581 46.4002 35.8595 46.4002 37.5999C46.3974 39.933 45.4694 42.1697 43.8197 43.8195C42.17 45.4692 39.9333 46.3972 37.6002 46.3999Z"
                        fill="#8DC73F"
                      />
                      <path
                        d="M42.2226 34.2463L36.0002 40.4687L33.1722 37.6399C33.0213 37.4942 32.8192 37.4135 32.6095 37.4154C32.3997 37.4172 32.199 37.5013 32.0507 37.6496C31.9024 37.798 31.8183 37.9986 31.8164 38.2084C31.8146 38.4181 31.8952 38.6202 32.041 38.7711L35.4346 42.1655C35.5846 42.3155 35.788 42.3997 36.0002 42.3997C36.2123 42.3997 36.4158 42.3155 36.5658 42.1655L43.3538 35.3775C43.4995 35.2266 43.5801 35.0245 43.5783 34.8148C43.5765 34.605 43.4924 34.4044 43.344 34.256C43.1957 34.1077 42.9951 34.0236 42.7853 34.0218C42.5755 34.0199 42.3735 34.1006 42.2226 34.2463Z"
                        fill="#8DC73F"
                      />
                    </svg>
                    <div class="flex flex-col ml-2">
                      <p class="font-semibold text-base">
                        {{ joinSessionDate }}
                      </p>
                      <p class="text-xs text-gray-light font-normal">
                        {{ joinSessionStartTime }} -
                        {{ joinSessionEndTime }}
                      </p>
                    </div>
                  </div>
                  <!-- <div class="flex justify-center items-center">
                    <button
                      class="bg-green-light px-6 text-sm transition-colors duration-150 text-white rounded-md focus:outline-none hover:text-green-light ring-1 ring-green-light hover:bg-white hover:border-green-light py-3 mb-20 font-medium"
                    >
                      Set Reminder
                    </button>
                  </div> -->
                  <div class="ring-gray-400 ring-1 mt-2 mb-12"></div>
                  <div class="flex justify-between">
                    <div class="font-semibold text-base">Share the love</div>
                    <div class="flex">
                      <!-- <button class="ml-2">
                        <svg
                          width="36"
                          height="28"
                          viewBox="0 0 36 28"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M34 1H2C1.44772 1 1 1.44772 1 2V26C1 26.5523 1.44772 27 2 27H34C34.5523 27 35 26.5523 35 26V2C35 1.44772 34.5523 1 34 1ZM2 0C0.895431 0 0 0.895431 0 2V26C0 27.1046 0.895431 28 2 28H34C35.1046 28 36 27.1046 36 26V2C36 0.895431 35.1046 0 34 0H2ZM18 21C17.7722 21 17.5526 20.9188 17.3815 20.7714C16.7351 20.2156 16.1119 19.6932 15.5621 19.2324L15.5593 19.23C13.9474 17.879 12.5554 16.7123 11.5869 15.563C10.5043 14.2782 10 13.06 10 11.7291C10 10.4361 10.4508 9.24325 11.2693 8.37008C12.0975 7.48659 13.234 7 14.4697 7C15.3933 7 16.2391 7.28717 16.9836 7.85348C17.3594 8.13933 17.7 8.48918 18 8.89725C18.3002 8.48918 18.6406 8.13933 19.0165 7.85348C19.761 7.28717 20.6068 7 21.5304 7C22.766 7 23.9026 7.48659 24.7308 8.37008C25.5493 9.24325 26 10.4361 26 11.7291C26 13.06 25.4958 14.2782 24.4132 15.5629C23.4447 16.7123 22.053 17.8788 20.4414 19.2296L20.4412 19.2298C19.8904 19.6913 19.2662 20.2145 18.6184 20.7717C18.4474 20.9188 18.2277 21 18 21Z"
                            fill="#C4C4C4"
                          />
                        </svg>
                      </button>
                      <button class="ml-2">
                        <svg
                          width="43"
                          height="28"
                          viewBox="0 0 43 28"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <mask id="path-1-inside-1_1071_5288" fill="white">
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M9.00047 0C7.8959 0 7.00047 0.895431 7.00047 2V9.57165C6.77735 9.53061 6.53621 9.56495 6.31451 9.69603L0.491048 13.1392C-0.163682 13.5263 -0.163683 14.4737 0.491047 14.8608L6.31451 18.304C6.53621 18.4351 6.77735 18.4694 7.00047 18.4283V26C7.00047 27.1046 7.8959 28 9.00047 28H40.1536C41.2582 28 42.1536 27.1046 42.1536 26V2C42.1536 0.895431 41.2582 0 40.1536 0H9.00047Z"
                            />
                          </mask>
                          <path
                            d="M7.00047 9.57165L6.81956 10.5552L8.00047 10.7724V9.57165H7.00047ZM6.31451 9.69603L5.80556 8.83523H5.80556L6.31451 9.69603ZM0.491048 13.1392L-0.0179046 12.2784L-0.0179051 12.2784L0.491048 13.1392ZM0.491047 14.8608L1 14H0.999999L0.491047 14.8608ZM6.31451 18.304L5.80556 19.1648L5.80556 19.1648L6.31451 18.304ZM7.00047 18.4283H8.00047V17.2276L6.81957 17.4448L7.00047 18.4283ZM8.00047 2C8.00047 1.44772 8.44819 1 9.00047 1V-1C7.34362 -1 6.00047 0.343147 6.00047 2H8.00047ZM8.00047 9.57165V2H6.00047V9.57165H8.00047ZM6.82347 10.5568C6.82521 10.5558 6.82645 10.5552 6.82719 10.5548C6.82757 10.5546 6.82785 10.5545 6.82802 10.5544C6.82819 10.5544 6.82828 10.5543 6.82828 10.5543C6.82829 10.5543 6.82822 10.5544 6.82808 10.5544C6.82795 10.5544 6.82776 10.5545 6.82752 10.5546C6.82703 10.5547 6.82642 10.5548 6.8257 10.555C6.82237 10.5555 6.82004 10.5552 6.81956 10.5552L7.18138 8.58815C6.73017 8.50516 6.24276 8.57674 5.80556 8.83523L6.82347 10.5568ZM1 14L6.82347 10.5568L5.80556 8.83523L-0.0179046 12.2784L1 14ZM0.999999 14H1L-0.0179051 12.2784C-1.32736 13.0526 -1.32737 14.9474 -0.0179047 15.7216L0.999999 14ZM6.82347 17.4432L1 14L-0.0179052 15.7216L5.80556 19.1648L6.82347 17.4432ZM6.81957 17.4448C6.82004 17.4448 6.82237 17.4445 6.8257 17.445C6.82642 17.4452 6.82703 17.4453 6.82752 17.4454C6.82776 17.4455 6.82795 17.4456 6.82808 17.4456C6.82822 17.4456 6.82828 17.4457 6.82828 17.4457C6.82828 17.4457 6.82819 17.4456 6.82802 17.4456C6.82785 17.4455 6.82757 17.4454 6.82719 17.4452C6.82645 17.4448 6.82521 17.4442 6.82346 17.4432L5.80556 19.1648C6.24276 19.4233 6.73017 19.4948 7.18137 19.4118L6.81957 17.4448ZM8.00047 26V18.4283H6.00047V26H8.00047ZM9.00047 27C8.44818 27 8.00047 26.5523 8.00047 26H6.00047C6.00047 27.6569 7.34361 29 9.00047 29V27ZM40.1536 27H9.00047V29H40.1536V27ZM41.1536 26C41.1536 26.5523 40.7059 27 40.1536 27V29C41.8105 29 43.1536 27.6569 43.1536 26H41.1536ZM41.1536 2V26H43.1536V2H41.1536ZM40.1536 1C40.7059 1 41.1536 1.44771 41.1536 2H43.1536C43.1536 0.343148 41.8105 -1 40.1536 -1V1ZM9.00047 1H40.1536V-1H9.00047V1Z"
                            fill="#C4C4C4"
                            mask="url(#path-1-inside-1_1071_5288)"
                          />
                        </svg>
                      </button> -->
                      <button
                        class="ml-2"
                        @click="onclickShareUrl"
                        id="share-url"
                      >
                        <svg
                          width="36"
                          height="28"
                          viewBox="0 0 36 28"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            x="0.5"
                            y="0.5"
                            width="35"
                            height="27"
                            rx="1.5"
                            stroke="#C4C4C4"
                          />
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M22 12C23.6569 12 25 10.6569 25 9C25 7.34315 23.6569 6 22 6C20.3431 6 19 7.34315 19 9C19 9.22315 19.0244 9.4406 19.0706 9.64985L15.7531 11.5652C15.2599 11.2096 14.6544 11 14 11C12.3431 11 11 12.3431 11 14C11 15.6569 12.3431 17 14 17C14.7442 17 15.4252 16.729 15.9495 16.2803L19.1319 18.1176C19.0461 18.3966 19 18.6929 19 19C19 20.6569 20.3431 22 22 22C23.6569 22 25 20.6569 25 19C25 17.3431 23.6569 16 22 16C21.3844 16 20.8122 16.1854 20.336 16.5034L16.95 14.5485C16.9828 14.3706 17 14.1873 17 14C17 13.7283 16.9639 13.465 16.8962 13.2147L20.1311 11.3469C20.6438 11.7557 21.2934 12 22 12Z"
                            fill="#8DC73F"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
              </section>
              <!-- Contact trainer -->
              <!-- <div class="flex items-center justify-center mt-8">
                <router-link
                  class="inline-flex items-center h-8 px-2 text-sm transition-colors duration-150 ring-1 ring-gray-darkest text-gray-light rounded-md focus:outline-none hover:text-white hover:bg-green-light hover:border-green-light py-5 font-medium"
                  :to="{
                    name: 'UserTrainerAbout',
                    params: {
                      trainer_id:
                        trainer && trainer.details && trainer.details.id,
                    },
                  }"
                  v-if="
                    (message_requests && message_requests.status == 1) ||
                    (message_requests && message_requests.status == 2)
                  "
                >
                  <span class="px-1"> Contact Trainer </span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.5"
                      d="M13 7l5 5m0 0l-5 5m5-5H6"
                    />
                  </svg>
                </router-link>
                <div v-else>
                  <router-link
                    class="inline-flex items-center h-8 px-2 text-sm transition-colors duration-150 ring-1 text-gray-light rounded-md focus:outline-none bg-white hover:text-white hover:bg-green-light ring-gray-darkest"
                    :to="{
                      name: 'UserTrainerAbout',
                      params: {
                        trainer_id:
                          trainer && trainer.details && trainer.details.id,
                        isContactModalOpen: true,
                      },
                    }"
                    v-if="trainer && trainer.details && trainer.details.id"
                  >
                    <span class="px-1">Contact Trainer</span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M13 7l5 5m0 0l-5 5m5-5H6"
                      />
                    </svg>
                  </router-link>
                </div>
              </div> -->
            </div>
          </section>
        </div>

        <!-- v-if="session && session.details && session.details.cost !== 0" -->
        <PaymentModal
          :value="openPaymentModal"
          v-if="sessionJoinData && session.details && openPaymentModal"
          :details="session && session.details"
          :batch="sessionJoinData && sessionJoinData.batch"
          :handleClose="handleClose"
          v-on:book-class="onBookClass"
        >
        </PaymentModal>
      </section>

      <!-- More sessions -->
      <section class="mt-10">
        <div class="py-4">
          <h6
            class="text-3xl leading-normal mt-0 mb-6 text-black font-semibold"
          >
            More Classes by
            <span class="capitalize text-green-light">
              {{ trainer && trainer.details && trainer.details.name }}
            </span>
          </h6>

          <TrainerSessionCardList
            :data="
              trainerActiveSessions &&
              trainerActiveSessions.data &&
              trainerActiveSessions.data.data
            "
          />
        </div>
      </section>

      <!-- Recommended sessions -->
      <section
        class=""
        v-if="recommended && recommended.length"
      >
        <div class="py-4">
          <h6
            class="text-xl leading-normal mt-0 mb-6 text-gray-dark font-semibold"
          >
            Recommended Classes
          </h6>
          <div>
            <RecommendedSessionCardList :data="recommended" />
          </div>
        </div>
      </section>
    </div>
    <Modal v-model="isShareModalOpen" :title="'Share link to Class'">
      <div class="space-y-4">
        <div>
          <p class="text-gray-dark font-semibold mb-4">Share link via</p>
          <ShareNetworkComponent :sharingUrl="sharingUrl" />
        </div>
        <div>
          <p class="text-gray-dark font-semibold mb-4">Share this link</p>
          <div class="flex items-center">
            <input
              class="w-full h-10 px-3 text-base text-gray-700 placeholder-gray-600 ring-1 ring-gray-300 rounded-lg focus:shadow-outline"
              type="text"
              placeholder="Sharing url"
              v-model="sharingUrl"
              disabled
            />
            <button
              type="button"
              class="h-10 px-2 ml-2 text-sm text-green-100 transition-colors duration-150 bg-green-light rounded-lg focus:shadow-outline hover:bg-green-light w-32"
              id="copy-url"
              @click.prevent="handleCopyUrlButton"
            >
              Copy URL
            </button>
          </div>
        </div>
      </div>
    </Modal>
    <!-- start modal for session completed and rating and reviews  -->
    <Modal
      :title="'Feedback for '+ (session && session.details && session.details.title)"
      v-model="showFeedbackModal"
      :whiteCross="'text-white'"
    >
      <SessionReviewPost
        v-if="user && user.user_type != 0"
        :data="batch"
        callerComp="sessionModal"
        v-on:hidePostReview="showFeedbackModal = false"
      />
    </Modal>
    <!-- end modal for session completed and rating and reviews  -->
  </UserLayout>
</template>

<script>
import SessionJoinModal from "@/components/SessionJoinModal.vue";
import SessionBatchesAvailable from "@/components/SessionBatchesAvailable";
import RecommendedSessionCardList from "@/components/RecommendedSessionCardList";
import TrainerSessionCardList from "@/components/TrainerSessionCardList";
import SessionReviewList from "@/components/SessionReviewList.vue";
import SessionBatchesJoined from "@/components/SessionBatchesJoined";
import PaymentModal from "@/components/t-components/PaymentModal";
import { Modal } from "@/components/t-components";
import ShareNetworkComponent from "@/components/social-sharing/ShareNetworkComponent";
import SessionDetailsComponents from "@/components/user/SessionDetailsComponents";
import SessionFeedbackModal from "@/components/user/SessionFeedbackModal.vue";
import UserLayout from "@/components/layouts/UserLayout";
import { Avatar, Rating } from "@/components/t-components";
import ClickOutside from "vue-click-outside";
import { mapGetters, mapActions } from "vuex";
import SessionRatingsList from "./SessionRatingsList.vue";
import SessionReviewPost from "@/components/SessionReviewPost";

export default {
  name: "SessionDetails",
  components: {
    Avatar,
    Rating,
    SessionBatchesJoined,
    PaymentModal,
    SessionBatchesAvailable,
    RecommendedSessionCardList,
    TrainerSessionCardList,
    SessionDetailsComponents,
    SessionFeedbackModal,
    SessionJoinModal,
    SessionReviewList,
    UserLayout,
    Modal,
    ShareNetworkComponent,
    SessionRatingsList,
    SessionReviewPost
},
  data() {
    return {
      batches: {},
      recommended: {},
      session: {},
      trainer: {},
      step: 1,
      openPaymentModal: false,
      interactTrainer: "",
      hasJoinedSession: false,
      joinSessionDate: "",
      joinSessionStartTime: "",
      joinSessionEndTime: "",
      sessionJoinData: {},
      isSessionJoinModalOpen: false,
      showPopper: false,
      paymentSuccessRedirectProps: {},
      wallet_balance: "",
      isContactTrainerModalOpen: false,
      message_requests: [],
      isSessionDetailsDesc: false,
      isTrainerDetailsDesc: false,
      TWOHUNDRED: 200,
      isBookSession: false,
      isSessionFeedbackModal: false,
      orderBy: "most_recent",
      ratingEditObj: {},
      isShareModalOpen: false,
      sharingUrl: '',
      user: JSON.parse(localStorage.getItem("user")),
      sessionRatingsData: {},
      showFeedbackModal: false,
      batch: {}
    };
  },
  watch: {
    orderBy() {
      this.getUserReviewRating({
        session_id: this.$route.params.id,
        query: {
          order_by: this.orderBy,
          entity_type: this.SESSION,
        },
      });
    },
    session (sessionData) {
      if (sessionData && sessionData.details && sessionData.details.id) {
        this.getUserReviewsHandler(sessionData.details.id)
      }
    },
    batches (batchData) {
      let pendingReview = JSON.parse(localStorage.getItem("sessionReview"))
      if (pendingReview && Object.keys(pendingReview).length && batchData &&
        batchData.joined && batchData.joined.data && batchData.joined.data.length) {
        let checkSessionSatus = batchData.joined.data.filter((batch) => {
          return batch.id === pendingReview.batchId && batch.session_id === pendingReview.sessionId && batch.status === 3
        })
        if (checkSessionSatus && checkSessionSatus.length) {
          this.batch = checkSessionSatus[0]
          this.showFeedbackModal = true
        }
      }
    },
    userReviewSessionPost () {
      this.getUserReviewsHandler(this.session.details.id)
    },
    userSessionDetail () {
      this.batches = this.userSessionDetail.batches;
    }
  },
  computed: {
    ...mapGetters([
      "userSessionDetail",
      "trainerDetail",
      "trainerActiveSessions",
      "userReviewRating",
      "userReviewSessionPost"
    ]),
  },
  methods: {
    ...mapActions([
      "getUserSessionDetail",
      "getUserSessionDetailMore",
      "getUserSessionDetailLess",
      "userSessionJoin",
      "userAddMoney",
      "getTrainerDetail",
      "getTrainerActiveSessions",
      "getUserReviewRating",
      "deleteUserReviewRating",
    ]),

    handleBookSession(id) {
      // this one
      if (this.getToken()) {
        const batch =
          this.batches.available &&
          this.batches.available.data &&
          this.batches.available.data.find((b) => b.id === id);
        this.joinSessionDate = this.getFormattedDate(batch.start_date, batch.timezone, 'MMM DD, YYYY');
        this.joinSessionStartTime = this.getFormattedDate(batch.start_date, batch.timezone, 'h:mm A');
        this.joinSessionEndTime = this.getFormattedDate(batch.end_date, batch.timezone, 'h:mm A');
        this.sessionJoinData.batch = batch;
        // this.isBookSession = !this.isBookSession;
        this.openPaymentModal = !this.openPaymentModal;

        this.paymentSuccessRedirectProps = {
          ...this.paymentSuccessRedirectProps,
          modalId: id,
        };
      } else {
        this.$store.commit('setAuthModalActive', true)
      }
    },

    handleJoinModal(id) {
      if (this.getToken()) {
        this.showPopper = false;
        const batch =
          this.batches.available &&
          this.batches.available.data &&
          this.batches.available.data.find((b) => b.id === id);
        this.sessionJoinData.batch = batch;
        this.isSessionJoinModalOpen = !this.isSessionJoinModalOpen;
        this.paymentSuccessRedirectProps = {
          ...this.paymentSuccessRedirectProps,
          modalId: id,
        };
      } else {
        this.$router.push({
          name: "Login",
        });
      }
    },

    handleBatchesJoinedModal(id) {
      this.showPopper = false;
      const batch = this.batches.joined.find((b) => b.id === id);
      this.sessionJoinData.batch = batch;
    },

    async handleJoinClick() {
      const data = {
        cost: this.sessionJoinData.batch.cost,
        group_id: this.sessionJoinData.batch.group_id,
        batch_id: this.sessionJoinData.batch.id,
        is_private: this.sessionJoinData.batch.is_private,
        session_id: this.sessionJoinData.batch.session_id,
      };
      await this.userSessionJoin(data);
      // this.isBookSession = !this.isBookSession;
      this.hasJoinedSession = !this.hasJoinedSession;
      await this.getUserSessionDetail(this.$route.params.id);
      this.batches = this.userSessionDetail.batches;
      // this.forceUpdate();
    },

    handleClose() {
      this.openPaymentModal = !this.openPaymentModal;
    },

    onBookClass() {
      this.step = 2;
      this.handleClose();
    },

    handleButtonClick() {
      const paymentSuccessRedirectProps = {
        ...this.paymentSuccessRedirectProps,
        redirectUrl: this.$route.path,
        componentName: "sessionPurchase",
      };
      localStorage.setItem(
        "paymentSuccessRedirectProps",
        JSON.stringify(paymentSuccessRedirectProps)
      );
      this.$router.push({ name: "UserAddMoney" });
    },

    handleShowMoreAvail(str) {
      const params = str.substring(str.indexOf("?"));
      this.getUserSessionDetailMore(this.$route.params.id + params);
    },

    handleShowLessAvail(str) {
      const params = str.substring(str.indexOf("?"));
      this.getUserSessionDetailLess(this.$route.params.id + params);
    },

    handleSessionFeedbackModal() {
      this.isSessionFeedbackModal = !this.isSessionFeedbackModal;
    },

    handleOrderBy(event) {
      this.orderBy = event.target.value;
    },

    handleRatingDel(rating_id) {
      this.deleteUserReviewRating({ rating_id });
    },

    handleRatingEdit(id) {
      var ratingObj = this.findObjById(
        this.userReviewRating && this.userReviewRating.rating_data,
        id
      );
      this.ratingEditObj = ratingObj;
      this.handleSessionFeedbackModal();
    },

    onclickShareUrl() {
      navigator.clipboard.writeText(window.location.href);
      document.getElementById("share-url").innerHTML = "Copied";
    },
    async handleShareButton() {
      this.isShareModalOpen = !this.isShareModalOpen;
      this.sharingUrl = this.getRouterHref(this.USERSESSIONDETAILS);
    },
    handleCopyUrlButton() {
      if (this.sharingUrl) {
        navigator.clipboard.writeText(this.sharingUrl);
        document.getElementById("copy-url").innerHTML = "Copied";
      }
    },
    getUserReviewsHandler (payload) {
      this.$store.dispatch('getSessionReviews', payload).then((res) => {
        if (res && res.current_page === 1) {
          this.sessionRatingsData = res
        } else if (res && res.current_page) {
          let prevData = this.sessionRatingsData && this.sessionRatingsData.data
          res.data = [...prevData, ...res.data]
          this.sessionRatingsData = res
        }
      })
    }
  },
  directives: {
    ClickOutside,
  },
  async created() {
    await this.getUserSessionDetail(this.$route.params.id);
    this.batches = this.userSessionDetail.batches;
    this.recommended = this.userSessionDetail.recommended;
    this.session = this.userSessionDetail.session;
    this.trainer = this.userSessionDetail.trainer;
    this.wallet_balance = this.userSessionDetail.wallet_balance;

    const paymentSuccessRedirectProps = JSON.parse(
      localStorage.getItem("paymentSuccessRedirectProps")
    );
    if (paymentSuccessRedirectProps && paymentSuccessRedirectProps.modalId) {
      this.handleJoinModal(paymentSuccessRedirectProps.modalId);
    }
    localStorage.removeItem("paymentSuccessRedirectProps");

    await this.getTrainerDetail(
      this.trainer && this.trainer.details && this.trainer.details.id
    );
    this.message_requests = this.trainerDetail.message_requests;
    const data = {
      id: this.trainer && this.trainer.details && this.trainer.details.id,
      sessionId: this.$route.params && this.$route.params.id,
    };
    const query = {
      page: 1,
    };
    await this.getTrainerActiveSessions({ data, query });
    const payload = {
      session_id: this.$route.params.id,
      query: {
        order_by: this.orderBy,
        entity_type: this.SESSION,
      },
    };
    await this.getUserReviewRating(payload);
  },
};
</script>

<style lang="scss" scoped>
.max-w-25 {
  width: 404px;
}

.text-currency {
  font-size: 28px;
  line-height: 40px;
}

.bg-gray-trainer {
  background: #f4f4f4;
}
.max-height-66 {
  max-height: 66vh;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.bg-f5f6ed {
  background-color: #f5f6ed;
}
.bg-f5f7ed {
  background-color: #f5f7ed;
}
progress {
  border: none;
  height: 24px;
  border-radius: 10px;
}
progress::-webkit-progress-value {
  background: #8dc73f;
  border-radius: 5px;
}
progress::-webkit-progress-bar {
  background: white;
  border-radius: 5px;
}
.booking-modal {
  border: 1px solid #f4f4f4;
  box-shadow: 0px 24px 34px rgba(0, 0, 0, 0.07);
  border-radius: 10px;
}
.scrolltoview-nav{
  border-bottom: 1px solid #E7EDF2;
  border-top: 1px solid #E7EDF2;
  padding-top: 16px;
  padding-bottom: 16px;
}
.scroll-active{
  position: relative;
  &:before{
    content: "";
    width: 100%;
    height: 2px;
    position: absolute;
    background: #060606;
    bottom: -23px;
  }
}
</style>